import React, { forwardRef } from 'react';
import { Box, Button, type ButtonProps } from '@chakra-ui/react';

export interface AleaIconButtonProps extends Omit<ButtonProps, 'leftIcon' | 'rightIcon'> {
  icon: React.ReactNode;
}

const AleaIconButton = forwardRef<HTMLButtonElement, AleaIconButtonProps>(
  (
    {
      icon,
      children,
      bg = 'alea.500',
      color = '#fff',
      h = '50px',
      minW = 'min-content',
      pl = '15px',
      pr = '15px',
      gap = '30px',
      fontWeight = 400,
      fontSize = '18px',
      borderRadius = '20px',
      borderWidth = '1px',
      borderStyle = 'solid',
      borderColor = '#DCDCDC',
      _hover = { bg: 'alea.600', borderColor: '#DCDCDC' },
      _active = { bg: 'alea.700', borderColor: '#DCDCDC' },
      _disabled = { opacity: 0.5, cursor: 'not-allowed' },
      ...rest
    },
    ref
  ) => {
    return (
      <Button
        ref={ref}
        type="button"
        variant="unstyled"
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
        bg={bg}
        color={color}
        h={h}
        minH={h}
        minW={minW}
        pl={pl}
        pr={pr}
        py={0}
        gap={gap}
        fontWeight={fontWeight}
        fontSize={fontSize}
        lineHeight="1.2"
        borderWidth={borderWidth}
        borderStyle={borderStyle}
        borderColor={borderColor}
        borderRadius={borderRadius}
        transition="background 0.15s ease"
        _hover={_hover}
        _active={_active}
        _disabled={_disabled}
        {...rest}
      >
        <Box as="span" display="flex" alignItems="center" flexShrink={0} lineHeight={0}>
          {icon}
        </Box>
        <Box as="span" whiteSpace="nowrap">
          {children}
        </Box>
      </Button>
    );
  }
);

AleaIconButton.displayName = 'AleaIconButton';

export default AleaIconButton;
